import * as React from "react";
import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Stack } from "@mui/material";

const PAGE_SIZE = 5;
const MIN_HEIGHT = 480;

const DataGridLayout = ({ children, rows, columns, onCellClick, sx }) => {
  // const [finalClickInfo, setFinalClickInfo] = useState(null);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);

  const handlePaginationModelChange = ({ pageSize: newPageSize }) => {
    setPageSize(newPageSize);
  };

  const handleOnCellClick = (params) => {
    // console.log("[UserDataGridLayout handleOnCellClick]", params);
    // setFinalClickInfo(params);
    onCellClick(params);
  };

  // console.log("finalClickInfo", finalClickInfo);

  // no data 이미지 S
  const getHeightSX = React.useCallback(() => {
    const calculatedHeight = Math.max(pageSize * 55 + 200, MIN_HEIGHT);
    return { height: calculatedHeight };
  }, [pageSize]);

  // no data 이미지 E
  return (
    <Stack sx={getHeightSX}>
      <DataGrid
        children={children}
        sx={sx}
        rows={rows}
        columns={columns}
        // baseTooltip
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: PAGE_SIZE },
          },
        }}
        pageSizeOptions={[PAGE_SIZE, 10]}
        hideFooterSelectedRowCount={true}
        rowHeight={55}
        onPaginationModelChange={handlePaginationModelChange}
        onCellClick={handleOnCellClick}
      />
    </Stack>
  );
};

export default DataGridLayout;
